"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailAttachmentDisposition = exports.EmailAttachmentType = void 0;
var EmailAttachmentType;
(function (EmailAttachmentType) {
    EmailAttachmentType["TEXT_CSV"] = "text/csv";
    EmailAttachmentType["TEXT_HTML"] = "text/html";
    EmailAttachmentType["TEXT_PLAIN"] = "text/plain";
})(EmailAttachmentType = exports.EmailAttachmentType || (exports.EmailAttachmentType = {}));
var EmailAttachmentDisposition;
(function (EmailAttachmentDisposition) {
    EmailAttachmentDisposition["INLINE"] = "inline";
    EmailAttachmentDisposition["ATTACHMENT"] = "attachment";
})(EmailAttachmentDisposition = exports.EmailAttachmentDisposition || (exports.EmailAttachmentDisposition = {}));
//# sourceMappingURL=EmailAttachment.js.map